export default "__VITE_ASSET__BHFH19F3__"